const classNames = {
    disabled: 'is-disabled',
    hover: 'is-hover',
    active: 'is-active',
    inActive: 'is-inactive',
    involved: 'is-involved',
    isLoading: 'is-loading',
    isVisible: 'is-visible',
    isCurrent: 'is-current',
    isDisplayed: 'is-displayed',
    lazyPreloader: 'js-lazy-loader',
    lazyImage: 'lazy__image',
    lazyLoaded: 'is-loaded',
    fixed: 'is-fixed',
    focused: 'is-focused',
    filled: 'is-filled',
    blurred: 'is-blurred',
    invalid: 'is-invalid',
    error: 'is-error',
    selected: 'is-selected',
    intlTelInput: 'js-intl-tel-input',
    intlTelInputMobile: 'iti-mobile',
    searchSelect: 'js-search-select'
};

const variables = {
    gsapDefaultDuration: .25,
    carouselDefaultDuration: 800,
    resizeDebounce: 100,
    inputDebounce: 200,
    debugLogs: true,
    debugLogsDisabledNotify: true,
    customEventNames: {
        resize: 'resize-done',
        selectDropdownSelected: 'select-dropdown-selected',
        recaptchaLoaded: 'recaptcha-loaded',
        validatedFormSubmit: 'validated-form-submitted',
        introImageLoaded: 'intro-image-loaded'
    },
    classNames,
    formValidationMessages: {
        invalid         : 'Некорректное значение',
        short           : 'input is too short',
        long            : 'input is too long',
        checked         : 'Должно быть отмечено',
        empty           : 'Пожалуйста, заполните это поле',
        select          : 'Please select an option',
        number_min      : 'too low',
        number_max      : 'too high',
        url             : 'invalid URL',
        number          : 'not a number',
        email           : 'Некорректный e-mail',
        email_repeat    : 'emails do not match',
        date            : 'invalid date',
        time            : 'invalid time',
        password_repeat : 'Пароли не совпадают',
        no_match        : 'no match',
        complete        : 'Ввод не завершён'
    },
    choicesOptions: {
        choices: [],
        allowHTML: true,
        loadingText: 'Загрузка...',
        noResultsText: 'Результаты не найдены',
        noChoicesText: 'Отсутствуют опции для выбора',
        itemSelectText: 'Нажмите, чтобы выбрать',
        classNames: {
            containerOuter: 'select',
            containerInner: 'select__inner',
            input: 'select__input',
            inputCloned: 'select__input--cloned',
            list: 'select__list',
            listItems: 'select__list--multiple',
            listSingle: 'select__list--single',
            listDropdown: 'select__list--dropdown',
            item: 'select__item',
            itemSelectable: 'select__item--selectable',
            itemDisabled: 'select__item--disabled',
            itemOption: 'select__item--choice',
            group: 'select__group',
            groupHeading : 'select__heading',
            button: 'select__button',
            activeState: classNames.active,
            focusState: classNames.focused,
            openState: 'is-open',
            disabledState: classNames.disabled,
            highlightedState: 'is-highlighted',
            selectedState: classNames.selected,
            flippedState: 'is-flipped',
            placeholder: 'select__placeholder'
        }
    },
    get windowWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    },
    get windowHeight() {
        return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    },
    scrollbarWidth:	window.innerWidth - document.documentElement.clientWidth,
    breakpoints: {
        m: 375,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
        xxl: 1400
    },
    selectors: {
        lazyElement: '.js-lazy-element'
    },
    dom: {
        header: document.getElementById('js-header'),
        wrapper: document.getElementById('js-page-wrapper'),
        footer: document.getElementById('js-footer'),
    },
    messages: {
        lazyError: 'Ошибка загрузки изображения'
    }
};

export default variables;
